import type { ErrorSupportInfo } from '@chefiapro/shared';

export interface SupportIncident {
  support: ErrorSupportInfo;
  requestId?: string;
  status: number;
  occurredAt: string;
}
let incidents: SupportIncident[] = [];
const listeners = new Set<() => void>();
export const supportStore = {
  subscribe(listener: () => void) {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
  snapshot: () => incidents,
  clear() {
    incidents = [];
    listeners.forEach((listener) => listener());
  },
  record(incident: SupportIncident) {
    // Only bounded, safe metadata in memory. No persistence, request payload, URL or identity.
    const last = incidents[0];
    if (
      last &&
      ((incident.requestId && last.requestId === incident.requestId) ||
        (!incident.requestId &&
          last.support.code === incident.support.code &&
          Date.now() - Date.parse(last.occurredAt) < 1500))
    )
      return;
    incidents = [incident, ...incidents].slice(0, 5);
    listeners.forEach((listener) => listener());
  },
};

export function supportReference(value?: string): string | undefined {
  // Server correlation IDs are identifiers, not free-form strings supplied by a user.
  return value && /^[a-zA-Z0-9_-]{8,100}$/.test(value) ? value : undefined;
}
export function fallbackSupport(code: string): ErrorSupportInfo {
  return {
    code,
    technicalCode: code,
    module: 'Sistema',
    category: 'Atendimento',
    title: code === 'NETWORK_ERROR' ? 'Conexão interrompida' : 'Operação não concluída',
    steps: [
      'Consulte o histórico antes de repetir uma gravação: a resposta pode não ter chegado.',
      'Se o problema continuar, copie os detalhes e entre em contato com o suporte.',
    ],
    fields: [],
  };
}
export function copyableIncident(incident: SupportIncident) {
  // Intentionally omit business message, field paths/values, URL, account, tokens and details.
  return [
    'ChefiaPro — atendimento',
    `Código: ${incident.support.code}`,
    `Código técnico: ${incident.support.technicalCode}`,
    `Módulo: ${incident.support.module}`,
    `HTTP: ${incident.status || 'sem resposta'}`,
    `Identificador: ${supportReference(incident.requestId) ?? 'não disponível (falha local ou de conexão)'}`,
    `Data/hora: ${incident.occurredAt}`,
  ].join('\n');
}

export function openSupportDetails() {
  window.dispatchEvent(new Event('chefiapro-open-error-support'));
}
